import { authorizedAction } from 'api'
import { ErrorProp } from './'

type ReactivateResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type ReactivateProps = {
  userId?: string
}

export async function reactivate({
  userId,
}: ReactivateProps): Promise<ReactivateResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Student.Reactivate',
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as ReactivateResponseProps
    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
